import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthpopupComponent, AuthpopupContext } from 'src/app/shared/components/authpopup/authpopup.component';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { WebNavService } from '../webnavigation.service';

// Sign-in and sign-out for the /render pages — the sign-in dialog the library and the discover
// landing use. The account itself is the profile menu's (render-profile-menu): its email and Sign
// Out; the white account popup it used to open is gone (owner, 2026-10-20).
@Injectable()
export class RenderAccountService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly firebaseAuth: FirebaseAuthService,
    private readonly webNavService: WebNavService,
  ) {}

  public get isSignedIn(): boolean {
    return !!this.firebaseAuth.currentUser;
  }

  // Runs `next` once the user is signed in — right away, or after the popup (which closes itself
  // on a successful sign-in). A dismissed popup runs `dismissed`, if given, else nothing happens.
  public whenSignedIn(next: () => void, context: AuthpopupContext = RenderAccountService.PREVIEW_CONTEXT, dismissed?: () => void): void {
    if (this.isSignedIn) {
      next();
      return;
    }
    this.openAuthPopup(context).afterClosed().subscribe(() => {
      if (this.isSignedIn) {
        next();
      } else {
        dismissed?.();
      }
    });
  }

  public openAuthPopup(context: AuthpopupContext = {}): MatDialogRef<AuthpopupComponent> {
    return this.dialog.open(AuthpopupComponent, { data: context, restoreFocus: false, panelClass: 'webpopup-overlay' });
  }

  // The app's sign-out; on /render it lands on the render landing (WebNavService.signOut).
  public signOut(): void {
    this.webNavService.signOut();
  }

  private static readonly PREVIEW_CONTEXT: AuthpopupContext = {
    title: 'Your preview starts here.',
    text: 'Sign in to save your model and keep your videos together. No card needed.',
  };
}
